export default __webpack_public_path__ + "static/media/FooterLogo.7827eed7.png";